import { enableProdMode, importProvidersFrom, isDevMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules, withComponentInputBinding } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { IonicStorageModule } from '@ionic/storage-angular';
import { TokenInterceptor } from '@shared/interceptors/token.interceptor';
import { ErrorInterceptor } from '@shared/interceptors/error.interceptor';
import { provideAnimations } from '@angular/platform-browser/animations';
import localeEn from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es-AR';
import localePt from '@angular/common/locales/pt';
import { registerLocaleData } from '@angular/common';
import { provideServiceWorker } from '@angular/service-worker';
import { register as swipperRegister } from 'swiper/element/bundle';

swipperRegister();

registerLocaleData(localeEn, 'en-US');
registerLocaleData(localeEs, 'es-AR');
registerLocaleData(localePt, 'pt-BR');

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom([IonicStorageModule.forRoot()]),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular({
      useSetInputAPI: true,
      mode: 'md',
    }),
    provideAnimations(),
    provideHttpClient(withInterceptors([TokenInterceptor, ErrorInterceptor])),
    provideRouter(routes, withPreloading(PreloadAllModules), withComponentInputBinding()),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
});
